import { IconColors, IconKeys } from '@components/icon/icon';
import { iconRenderer } from '@components/icon/icon-renderer';
import {
  EmptyState, EmptyStateSizes, EmptyStateTypes, FeaturedIconColors,
} from '@leegality/leegality-react-component-library';
import PropTypes from 'prop-types';
import React from 'react';
import { getApiErrorMessage } from '../utils/get-api-error-message';

const renderErrorIcon = () => iconRenderer({ iconName: IconKeys.AlertTriangle, color: IconColors.ERROR });

// Shown when the feedback form can't be loaded; the text is the BE's message.
const FeedbackErrorScreen = ({ error }) => (
  <div className="flex items-center justify-center h-full p-6 bg-white">
    <EmptyState
      type={EmptyStateTypes.CUSTOM}
      size={EmptyStateSizes.MEDIUM}
      color={FeaturedIconColors.ERROR}
      renderIcon={renderErrorIcon}
      text={getApiErrorMessage(error)}
    />
  </div>
);

FeedbackErrorScreen.propTypes = {
  error: PropTypes.shape({
    message: PropTypes.string,
    response: PropTypes.shape({}),
  }),
};

FeedbackErrorScreen.defaultProps = {
  error: null,
};

export default FeedbackErrorScreen;
